<template>
<v-container class="hideComment">
    <v-layout row wrap>
        <v-flex xs9>
            <v-list-tile-content class="hideMessage" data-qe-id="hidden-comment_hidden-message">
                {{communityCommonConstant.post.HIDE_COMMENT}}
            </v-list-tile-content>
        </v-flex>
        <v-flex xs3 text-xs-right>
            <v-btn id="undo_unitTest" class="primary_btn transparent" flat data-qe-id="hidden-comment_unhide_btn" @click="unHideComments">
                {{communityCommonConstant.post.UNDO}}
            </v-btn>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
    import { communityCommonConstant } from '../communityCommon.constant';
    import { mapActions } from "vuex";
    import { storeAction } from '@/store/storeActions.constant';

    export default {
        name: 'HiddenComment',
        data: () => ({
            communityCommonConstant,
        }),
        props: {
            comment: {
                type: Object,
                required: true,
            },
        },
        methods: {
            ...mapActions('chapter', [
                storeAction.unHidePost,
            ]),
            unHideComments() {
                this.unHidePost(this.comment.id);
            },
        },
        computed: {
            ownerName() {
                return `${this.comment.authorFirstName} ${this.comment.authorLastName}`;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

.hideComment {
  background: rgba($ypo-title-border, 0.3);
  border: 1px solid rgba($ypo-title-border, 0.6);
  border-radius: 4px;
  margin: 10px 10px 10px 10px;
  padding: 5px 0 5px 0;
  font-size: 12px;
  width: auto;
  @include breakpoint(xs) {
        padding-right:20px;
  }
  
  .hideMessage{
    color: $black;
    font-family: "Noto Sans";
    font-size: 14px;
    margin-left: 20px;
  }
}

</style>
